/**
 * 企業規模カテゴリー
 */
export const CompanySizeCode = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const

export type CompanySizeCodeValue =
  (typeof CompanySizeCode)[keyof typeof CompanySizeCode]

export const CompanySizeLabel: { [key: string]: string } = {
  [CompanySizeCode.SMALL]: '小規模(10人以下)',
  [CompanySizeCode.MEDIUM]: '中規模(11-300人)',
  [CompanySizeCode.LARGE]: '大規模(301人以上)',
}

export const CompanySizeValues = Object.entries(CompanySizeLabel).map(
  ([code, value]) => ({
    code,
    value,
  })
)
